import { z } from "zod";

import { maintenanceMessages } from "../maintenance.intl";

import { dateValidator } from "@/utils/core/validators";

export const MaintenanceScheduleSchema = z
  .object({
    startDate: dateValidator(
      true,
      maintenanceMessages.startDateRequired.defaultMessage,
    ),
    startTime: dateValidator(
      true,
      maintenanceMessages.startTimeRequired.defaultMessage,
    ),
    endDate: dateValidator(false),
    endTime: dateValidator(false),
    reminderType: z.enum(["CUSTOM", "NONE", "IMMEDIATE"]),
    reminderDate: dateValidator(false),
    reminderTime: dateValidator(false),
    notice: z.string().max(300).optional(),
  })
  .superRefine((data, ctx) => {
    const addIssue = (
      path: keyof typeof data,
      message: string | undefined,
    ): void => {
      ctx.addIssue({
        message,
        path: [path],
        code: "custom",
      });
    };

    const buildDateTime = (date: string | Date, time: string | Date): Date => {
      const dateTime = new Date(date);
      const timeValue = new Date(time);
      dateTime.setHours(timeValue.getHours(), timeValue.getMinutes(), 0, 0);

      return dateTime;
    };

    if (data.endDate && !data.endTime) {
      addIssue("endTime", maintenanceMessages.endTimeRequired.defaultMessage);
    }

    if (!data.endDate && data.endTime) {
      addIssue("endDate", maintenanceMessages.endDateRequired.defaultMessage);
    }

    if (data.reminderType !== "CUSTOM") {
      return;
    }

    if (!data.reminderDate) {
      addIssue(
        "reminderDate",
        maintenanceMessages.reminderDateRequired.defaultMessage,
      );
    }

    if (!data.reminderTime) {
      addIssue(
        "reminderTime",
        maintenanceMessages.reminderTimeRequired.defaultMessage,
      );
    }

    if (
      !data.startDate ||
      !data.startTime ||
      !data.reminderDate ||
      !data.reminderTime
    ) {
      return;
    }

    const startDateTime = buildDateTime(data.startDate, data.startTime);
    const reminderDateTime = buildDateTime(
      data.reminderDate,
      data.reminderTime,
    );

    if (reminderDateTime >= startDateTime) {
      addIssue(
        "reminderTime",
        maintenanceMessages.reminderBeforeStartRequired.defaultMessage,
      );
    }
  });
